//react
import React, { useState } from "react";
import { useParams } from "react-router-dom";

//material UI
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";

//react redux
import { useDispatch, useSelector } from "react-redux";

//slices
import {
  // addAnalysisAndGraphs,
  setConfidenceLevel,
  setHypothesizedMean,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

//functions
import {
  createAnalysis,
  getHeaders,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getPairedTTestResults } from "../../../utils/computation/getPairedTTestResults";
import { getBoxPlot } from "../../../utils/computation/getBoxPlot";
import { getBoxPlotGroup } from "../../../utils/computation/getBoxPlotGroup";
import { getHistogram } from "../../../utils/computation/getHistogram";
import { getIndividualPlot } from "../../../utils/computation/getIndividualPlot";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const PairedTTestModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [hypothesisTest, setHypothesisTest] = useState(false);
  // const [Column, setColumn] = useState("");
  const [firstCol, setFirstCol] = useState("");
  const [secondCol, setSecondCol] = useState("");
  const [graphs, setgraphs] = useState({
    isHistogram: false,
    isBoxplot: false,
    isIVP: false,
  });

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data, confidenceLevel } = useSelector((state) => state.dataTable);

  //functions

  // const handleChange = (event) => {
  //   setColumn(event.target.value);
  // };

  const handleGraphCBChange = (event) => {
    setgraphs({
      ...graphs,
      [event.target.name]: event.target.checked,
    });
  };
  // const handleHypothesisTestChange = (event) => {
  //   setHypothesisTest(event.target.checked);
  // };
  const handleChangeConfidenceLevel = (value) => {
    dispatch(setConfidenceLevel(value));
  };
  const handleChangeHypothesizedMean = (value) => {
    dispatch(setHypothesizedMean(value));
  };
  const computeTTest = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const firstValue = getColumnValues(data, firstCol);
    const secondValue = getColumnValues(data, secondCol);
    // const header1 = getHeaders(data, firstCol);
    // const header2 = getHeaders(data, secondCol);
    // const header = [header1[0], header2[0]];
    closeMenu();

    if (firstValue.length > 0 && secondValue.length > 0) {
      const result = await getPairedTTestResults(
        firstValue,
        secondValue,
        confidenceLevel
      );
      // const [ivpResult, boxplotResult, histogramResult] = await Promise.all([
      //   graphs.isIVP &&
      //     getIndividualPlot({
      //       value: [result.container],
      //       header: ["Paired array"],
      //     }),
      //   graphs.isBoxplot &&
      //     getBoxPlotGroup([result.container], ["Paired array"]),
      //   graphs.isHistogram && getHistogram([result.container]),
      // ]);

      // delete boxplotResult.inputs;
      // delete histogramResult.inputs;

      if (!result) return;
      //populate analysis object
      const pairedTTestResult = {
        ...result,
        // ivpResult,
        // boxplotResult: boxplotResult,
        // histogramResult: histogramResult,
        column: firstCol + ", " + secondCol,
        graphs,
        hypothesisTest,
        confidenceLevel,
        title: "Paired t",
      };

      // console.log({ pairedTTestResult });

      try {
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          pairedTTestResult
        );
        pairedTTestResult.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }
      // dispatch(addAnalysisAndGraphs(pairedTTestResult));
    } else {
    }

    dispatch(setConfidenceLevel(95));
    dispatch(setIsLoading());
  };

  return (
    <div>
      <Modal
        open={openModal === title}
        onClose={closeMenu}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <h1> Paired t</h1>
          <Grid
            item
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            style={{
              padding: "10px",
            }}
          >
            <Grid item xs={6} p={1}>
              <h3> Data Range</h3>
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Select 1st column for the test
              </h3>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                <InputLabel id="demo-simple-select-label">Column</InputLabel>
                <Dropdown
                  value={firstCol}
                  onChange={(e) => setFirstCol(e.target.value)}
                />
              </FormControl>
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Select 2nd column for the test
              </h3>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                <InputLabel id="demo-simple-select-label">Column</InputLabel>
                <Dropdown
                  value={secondCol}
                  onChange={(e) => setSecondCol(e.target.value)}
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} p={1}>
              <h3> Additional Options</h3>
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Confidence level
              </h3>
              <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                label="Type a number between 0 to 100.0"
                sx={{ mt: 1 }}
                defaultValue={95}
                type="number"
                onChange={(e) => handleChangeConfidenceLevel(e.target.value)}
              />
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Alternative hypothesis
              </h3>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                {/* <InputLabel id="demo-simple-select-label">
                  hypothesis
                </InputLabel> */}
                {/* <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={AH}
                  label="AH"
                  onChange={handleChangeAH}
                >
                  <MenuItem value={"A"}>Mean {"<"} hypothesized mean</MenuItem>
                  <MenuItem value={"B"}>Mean ≠ hypothesized mean</MenuItem>
                  <MenuItem value={"C"}>Mean {">"} hypothesized mean</MenuItem>
                </Select> */}
                <TextField
                  disabled
                  id="outlined-disabled"
                  label="hypothesis"
                  defaultValue="Difference ≠ hypothesized difference"
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} p={1}>
              <h4>Difference = mean of (Sample 1 - Sample 2)</h4>

              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Hypothesized Difference:
              </h3>
              <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                label="Type mean here"
                sx={{ mt: 1 }}
                onChange={(e) => handleChangeHypothesizedMean(e.target.value)}
              />
            </Grid>

            <Grid item xs={6} p={1}>
              <h3
                style={{
                  marginTop: "5px",
                }}
              >
                Graphs
              </h3>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Histogram"
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    value="Histogram of Differences"
                    control={
                      <Checkbox
                        checked
                        disabled
                        onChange={handleGraphCBChange}
                        name="isHistogram"
                      />
                    }
                    label="Histogram of Differences"
                  />
                  {/* <FormControlLabel
                    value="Individual value plot"
                    control={
                      <Checkbox
                      checked
                        disabled onChange={handleGraphCBChange} name="IVP" />
                    }
                    label="Individual value plot"
                  /> */}
                  <FormControlLabel
                    value="Individual value plot of Differences"
                    control={
                      <Checkbox
                        checked
                        disabled
                        onChange={handleGraphCBChange}
                        name="isIVP"
                      />
                    }
                    label="Individual value plot of Differences"
                  />

                  <FormControlLabel
                    value="Boxplot of Differences"
                    control={
                      <Checkbox
                        checked
                        disabled
                        onChange={handleGraphCBChange}
                        name="isBoxplot"
                      />
                    }
                    label="Boxplot of Differences"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <div style={{ display: "flex", float: "right" }}>
            <Button
              variant="outlined"
              style={{
                borderRadius: "7px",
              }}
              onClick={closeMenu}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{
                width: "auto",
                marginLeft: "10px",
                borderRadius: "7px",
              }}
              onClick={() => computeTTest()}
            >
              Run Function
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default PairedTTestModal;
